// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { controlsContainerStyles } from "@cahaba/Overrides/Widgets/ProductList/ProductListControlsContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

controlsContainerStyles.container = {
    gap: 0,
    css: css`
        background: #f0eeee 0% 0% no-repeat padding-box;
        border: 1px solid #d6d6d6;
        padding: 10px 10px;
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css``,
                css``,
                css``,
                css`
                    margin-right: 25px;
                    margin-left: 25px;
                `,
                css`
                    margin-right: 25px;
                    margin-left: 25px;
                `,
            ]);
        }}
        width: auto;
    `,
    offsetProps: {
        style: {
            alignItems: "center",
        },
    },
};

controlsContainerStyles.tableViewContainer = {
    gap: 0,
    css: css`
        background: white 0% 0% no-repeat padding-box;
        border: 1px solid #d6d6d6;
        padding: 10px 10px;
        width: auto;
    `,
    offsetProps: {
        style: {
            alignItems: "center",
        },
    },
};

controlsContainerStyles.countGridItem = {
    width: [12, 12, 12, 9, 9],
};

controlsContainerStyles.sortGridItem = {
    width: [12, 12, 6, 3, 3],
    css: css`
        > div {
            text-align: left;
        }
        text-align: left;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        > div {
                            text-align: center;
                        }
                    `,
                ],
                "max",
            )}
    `,
};

controlsContainerStyles.sortTableViewGridItem = {
    width: [12, 12, 3, 2, 2],
    css: css`
        > div {
            text-align: left;
        }
        text-align: left;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        > div {
                            text-align: center;
                        }
                    `,
                ],
                "max",
            )}
    `,
};

controlsContainerStyles.filterTableViewGridItem = {
    width: [0, 0, 1, 2, 2],
};

controlsContainerStyles.viewSelectGridItem = {
    width: [0, 0, 6, 2, 2],
};

controlsContainerStyles.viewSelectTableViewGridItem = {
    width: [0, 0, 3, 2, 2],
};

controlsContainerStyles.resultsGridItem = {
    width: [12, 12, 12, 7, 7],
};

controlsContainerStyles.resultsTableViewGridItem = {
    width: [12, 12, 5, 6, 6],
};
